// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"7339a46f","453":"5e443b8b","455":"066f1021","665":"10303550","704":"4a4093f6","977":"12e87233"}[chunkId] + ".chunk.js";
};